import { render } from "./HTMLSwitch.vue?vue&type=template&id=493adac9&ts=true"
import script from "./HTMLSwitch.vue?vue&type=script&lang=ts"
export * from "./HTMLSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__